import { ModalError } from 'src/shared/modalProvider';

export class AuthError extends Error {
  readonly name = 'AuthError';
  constructor(message: string, options?: { cause: Error }) {
    super(message, options);
    // https://github.com/microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
    Object.setPrototypeOf(this, AuthError.prototype);
  }
}

export class RegistrationRequiredError extends AuthError {
  #sessionId?: string;
  constructor(registrationSession?: string) {
    super('Registration Required');
    this.#sessionId = registrationSession;
  }
  get sessionId() {
    return this.#sessionId;
  }
}

export class OTPResourceChange extends AuthError {
  constructor() {
    super('Client requested change OTP resource');
  }
}

export const unknownToAuthError = (err: unknown) => {
  if (err instanceof ModalError) {
    return new AuthError('Operation cancelled', { cause: err });
  } else if (err instanceof Error) {
    return new AuthError('Unknown error occurred.', { cause: err });
  }
  return new AuthError('Unknown error occurred.');
};
